interface IMiniCartResponse {
    success: boolean,
    html: string,
    total: number,
    message: string,
    slug?: string,
    description?: string
    datalayer?: any,
    item_name?: string
    insider_sdk?:any
    insider_search:any
}
interface ICheckValidateBundle {
    success: boolean,
    message: string
}
import { eventCart } from "./MiniCart";
import { showAddToCartNotification } from '~/composables/useAddToCartNotification';
import type { ISingleItem } from '~/types/track-item';
import { useCustomGtm } from '~/composables/useEventTagManager';
import { useInsiderSdk } from '~/composables/insiderSdk';

import { useInsiderSearchTracking } from '~/composables/insiderSearch'
const { getUUidInsiderSearch, sendInsiderEvent } = useInsiderSearchTracking()

const atcAlreadyInProcess = ref<boolean>(false);
export const initAddToCart = () => {
    if (atcAlreadyInProcess.value == true) {
        return false;
    }
    atcAlreadyInProcess.value = false;

    const atcBtns = document.querySelectorAll(".single_add_to_cart_button");
    if (atcBtns.length > 0) {
        atcBtns.forEach((atcBtn: Element) => {
            if (atcBtn instanceof HTMLElement) {
                atcBtn.addEventListener('click', function (event) {
                    event.preventDefault();
                    atcBtn.blur();
                    const bundleItems = document.querySelector(".yith-wcpb-product-bundled-items");
                    if (bundleItems) {
                     let valid = true;
                        if (atcBtn.classList.contains("check_bundle_add_cart")) {
                            // Bundle
                            const min_distinct = bundleItems.getAttribute("data-min-distinct") ?? 0;
                            const max_distinct = bundleItems.getAttribute("data-max-distinct") ?? 0;

                            var bundle_id_variations: string[] = [];
                            var bundleId = document.querySelector("input[name=add-to-cart]") as HTMLInputElement;
                            var bundleParentId = 0;
                            if (bundleId) {
                                bundleParentId = parseInt(bundleId.value);
                            }
                            var bundleQty = 1;
                            let bundleVariationIds = [];

                            if (parseInt(min_distinct) > 0 || parseInt(max_distinct) > 0) {
                                // Get all product items first
                                const productItems = document.querySelectorAll('.yith-wcpb-product-bundled-item');

                                if (productItems.length > 0) {
                                    productItems.forEach(productItem => {
                                        const optionalInput = productItem.querySelector<HTMLInputElement>('.yith-wcpb-bundled-optional');

                                        // If product has optional checkbox and it's checked
                                        if (optionalInput?.checked) {
                                            const variationInput = productItem.querySelector<HTMLInputElement>('.variation_id:not(.variable_variation_id)');
                                            if (variationInput?.value) {
                                                bundleVariationIds.push(variationInput.value);
                                            }
                                        }
                                        // If product doesn't have optional checkbox (mandatory product)
                                        else if (!optionalInput) {
                                            const variationInput = productItem.querySelector<HTMLInputElement>('.variation_id:not(.variable_variation_id)');
                                            if (variationInput?.value) {
                                                bundleVariationIds.push('');
                                            }
                                        }
                                    });
                                }

                            } else {
                                bundleVariationIds = document.querySelectorAll<HTMLInputElement>(".variation_id:not(.variable_variation_id)") as NodeListOf<HTMLInputElement>;
                            }

                            if (bundleVariationIds.length > 0) {
                                for (let i = 0; i < bundleVariationIds.length; i++) {
                                    if (bundleVariationIds[i].value === "0") {
                                        alert("Please select product option(s) before add to cart");
                                        valid = false;
                                        event.preventDefault();
                                        break;

                                    }
                                    bundle_id_variations.push(bundleVariationIds[i].value);
                                }
                            }

                            var pItemIds = document.querySelectorAll<HTMLInputElement>(".p_item_id") as NodeListOf<HTMLInputElement>;
                            if (pItemIds.length > 0) {
                                pItemIds.forEach((item, index) => {
                                    bundle_id_variations.push(item.value);
                                })
                            }
                            const bundleData = {
                                action: "yith_check_validate_bundle",
                                p_id: bundleParentId,
                                qty: bundleQty,
                                id_variations: bundle_id_variations,
                            }

                            const cartItemData: { [key: string]: string } = {};
                            const bunleOptional : { [key: string]: string } = {};
                            const bundleForm = document.querySelector(".yith-wcpb-bundle-form") as HTMLFormElement | null;
                            if (bundleForm) {
                                const hiddenInputs = bundleForm.querySelectorAll<HTMLInputElement>('input[type="hidden"]') as NodeListOf<HTMLInputElement>;
                                if (hiddenInputs.length > 0) {
                                    hiddenInputs.forEach((input) => {
                                        if (input.name) {
                                           cartItemData[input.name] = input.value;
                                             bunleOptional[input.name] = input.value;
                                        }
                                    });
                                }

                                const bundleQtys = bundleForm.querySelectorAll<HTMLInputElement>('input.yith-wcpb-bundled-quantity') as NodeListOf<HTMLInputElement>;
                                if (bundleQtys.length > 0) {
                                    bundleQtys.forEach((input) => {
                                        if (input.name) {
                                            cartItemData[input.name] = input.value;
                                             bunleOptional[input.name] = input.value;
                                        }
                                    });
                                }
                                const bundleOptionals = bundleForm.querySelectorAll<HTMLInputElement>('input.yith-wcpb-bundled-optional');

                                if (bundleOptionals.length > 0) {
                                    bundleOptionals.forEach((input) => {
                                        if (input.name && input.checked) {
                                            cartItemData[input.name] = input.value;
                                            bunleOptional[input.name] = input.value;
                                        }
                                    });
                                }
                                const selectedAttributes = bundleForm.querySelectorAll<HTMLSelectElement>('select.yith-wcpb-select-for-variables');
                                if (selectedAttributes.length > 0) {
                                    selectedAttributes.forEach((select) => {
                                        if (select.name) {
                                           cartItemData[select.name] = select.value;
                                            bunleOptional[select.name] = select.value;
                                        }
                                    });
                                }
                            }

                            delete bunleOptional["add-to-cart"];
                             const freeChainProductIdElement = document.querySelector("#chain-options-free") as HTMLInputElement | null;
                            const freeChainProductId = freeChainProductIdElement?.value || "";

                            const customGroupIdBundle = Date.now().toString() + Math.random().toString(36).substring(2);

                            const bundleATCData = {
                                action: "yith_bundle_add_to_cart_api",
                            p_id: bundleParentId,
                            qty: bundleQty,
                            variation_id: 0,
                            variation: [],
                            cart_item_data: [cartItemData],
                            ...(Object.keys(bunleOptional).length > 0 && bunleOptional),
                            ...(freeChainProductId !== '' && { custom_group_id: customGroupIdBundle }),
                            ...(freeChainProductId !== '' && { is_attached: true }),
                        }
                           
                            if (bundleId !== null && valid) {
                                handleDisableState(true);
                                handleLoadingState(true);
                               checkValidateBundle(bundleData, bundleATCData);
                                //addBundleToCart(bundleATCData);
                            }
                        }
                        // end bundle ------------------------
                    } else {

                        var maxQty = 1;
                        var qty = 1;

                        const formATC = atcBtn.closest("form.cart") as HTMLFormElement;
                        const id = (atcBtn as HTMLInputElement).value;
                        const product_qty = 1;
                        const product_id = (formATC.querySelector("input[name=product_id]") as HTMLInputElement)?.value || id;
                        const variation_id = (formATC.querySelector("input[name=variation_id]") as HTMLInputElement)?.value || 0;
                        const variations: Record<string, any> = {};

                        const selectElements = formATC.querySelectorAll("select");
                        if (selectElements.length > 0) {
                            selectElements.forEach((select) => {
                                if (
                                    !(select as HTMLSelectElement).classList.contains("chain-options__chain-select") &&
                                    !(select as HTMLSelectElement).classList.contains("chain-options__variation-select")
                                ) {
                                    variations[(select as HTMLSelectElement).name] = (select as HTMLSelectElement).value; // Use type assertion
                                }
                            });
                        }

                        const initialsValues = (formATC.querySelector("input[name=initialsValues]") as HTMLInputElement)?.value || '';

                        // Validate initialsValues if initials dropdowns are present
                        if (initialsValues) {
                            try {
                                const parsedInitials = JSON.parse(initialsValues);
                                if (parsedInitials && typeof parsedInitials === 'object') {
                                    const values = Object.values(parsedInitials);
                                    if (values.length > 0 && values.some((val: any) => !val || String(val).trim() === '')) {
                                        alert("Please select all initials letters");
                                        return;
                                    }
                                }
                            } catch (e) {
                                console.error('Error parsing initialsValues:', e);
                            }
                        }

                        interface IAddToCart {
                            action: string,
                            product_id: Number,
                            product_sku: string | null,
                            quantity: Number,
                            variation_id: Number,
                            variations: Record<string, any>,
                            initialsValues: string | null,
                            [key: string]: any
                        }
                        var data: IAddToCart = {
                            action: "woocommerce_add_to_cart_api",
                            product_id: Number(product_id),
                            product_sku: "",
                            quantity: Number(product_qty),
                            variation_id: Number(variation_id),
                            variations: variations,
                            initialsValues: initialsValues
                        };
                        // Engraving
                        if (document.querySelectorAll(".alt-engraving-design-wrapper").length > 0) {
                            const formData = new FormData();
                            document.querySelectorAll(".alt-engraving-design-row").forEach((row, index) => {
                                const designInput = row.querySelector<HTMLInputElement>(".alt-engraving-desgin-img:checked");
                                const design = designInput?.value || '';

                                formData.append(`engraving_item[${index}][design]`, design);

                                const maskInput = row.querySelector<HTMLInputElement>(".alt-engraving-desgin-mask");

                                if (maskInput?.checked) {
                                    const nameInput = row.querySelector<HTMLInputElement>(".alt-engraving-desgin-name");
                                    const fontInput = row.querySelector<HTMLInputElement>(".alt-engraving-desgin-font");
                                    const pidInput = row.querySelector<HTMLInputElement>(".alt-engraving-desgin-product_fee");

                                    formData.append(`engraving_item[${index}][name]`, nameInput?.value || '');
                                    formData.append(`engraving_item[${index}][font]`, fontInput?.value || '');
                                    formData.append(`engraving_item[${index}][pid]`, pidInput?.value || '');
                                }
                            });

                            formData.forEach((value, key) => {
                                data[key] = value;
                            });
                        }
                        // Chain Options
                        const chainOptionsContent = document.querySelector('.chain-options__content');
                        if (chainOptionsContent) {
                            const formData = new FormData();

                            const variationSelect = document.querySelector(".is_active_op .chain-options__variation-select") as HTMLSelectElement | null;
                            const chainElements = document.querySelectorAll('.chain-options__select-chain');

                            let isAnyActiveWithNewPrice = Array.from(chainElements).some(el => {
                                return el.classList.contains('is_active_op') && el.querySelector('.pt_new_price');
                            });

                            if (variationSelect) {
                                const chainSelectedOption = variationSelect.selectedOptions[0];
                                const chainSelectedVal = chainSelectedOption?.getAttribute('data-value') || '';
                                const chainSelectedAttributes = chainSelectedOption?.getAttribute('data-attributes') || '';

                                if (chainSelectedVal === "Select" || chainSelectedVal === "") {
                                    alert("Please select a chain option");
                                    return;
                                }

                                formData.append('chain_options[variation_id]', chainSelectedVal);
                                formData.append('chain_options[attributes]', chainSelectedAttributes);
                            }
                            const freeChainProductIdElement = document.querySelector("#chain-options-free") as HTMLInputElement | null;
                                const freeChainProductId = freeChainProductIdElement?.value || "";
                                formData.append('chain_options[free_product_id]', freeChainProductId);
                                if (freeChainProductId != '') {
                                 isAnyActiveWithNewPrice = true;
                            }
                            // check chain option active
                            if (isAnyActiveWithNewPrice) {
                                const productIdElement = document.querySelector(".is_active_op #chain-options__product-id") as HTMLInputElement | null;
                                const productId = productIdElement?.value || "";
                                const customGroupId = Date.now().toString() + Math.random().toString(36).substring(2);

                                formData.append('chain_options[product_id]', productId);
                                formData.append('chain_options[is_added]', "false");
                                formData.append('is_attached', "true");
                                formData.append('custom_group_id', customGroupId);
                            }

                            // Convert FormData to object
                            formData.forEach((value, key) => {
                                data[key] = value;
                            });
                        }
                        // Free Bracelet
                        const freeBraceletSelected: string = (document.querySelector("#free_bracelet_selected") as HTMLInputElement)?.value ?? "";
                        const jsBraceletSelected: string = (document.querySelector("#is_bracelet_product") as HTMLInputElement)?.value ?? "";
                        data['freeBraceletSelected'] = freeBraceletSelected;
                        data['jsBraceletSelected'] = jsBraceletSelected;

                        // customise
                        const mainProduct = document.querySelector(".main_product--customise");
                        if (mainProduct) {
                            // select variations
                            const selectedItems = document.querySelectorAll(".variations--customise .jos_variation .item_exits.selected");

                            if (selectedItems.length) {
                                // Initialize the customise object if it doesn't exist
                                if (!data.customise) {
                                    data.customise = {};
                                }

                                data.customise.ids = Array.from(selectedItems)
                                    .map(item => item.id)
                                    .join(',');
                            }


                            // Initialize customise object if not exists
                            if (!data.customise) {
                                data.customise = {};
                            }

                            const ids = document.getElementById("ids") as HTMLInputElement | null;
                            const multiNameValue = document.getElementById("multiNameValue") as HTMLInputElement | null;

                            if (ids && multiNameValue) {
                                const totalChars = document.getElementById("multiNameValue-totalChars") as HTMLInputElement | null;
                                const names: Record<string, string> = JSON.parse(multiNameValue.value || '{}');
                                const lengthName = Object.values(names).reduce((total, name) => total + name.length, 0);
                                const maxChars = Number(totalChars?.value);

                                if (totalChars?.value.trim() && Number.isFinite(maxChars) && lengthName > maxChars) {
                                    alert(`Total characters allowed for this product is ${maxChars}, please re-enter your text.`);
                                    return;
                                }

                                data.customise.ids = ids.value;
                                data.customise.multiNameValue = names;
                            }

                            // Engraving handling

                            const customise_engraving_name = document.querySelector("input[name='customise-engraving-name']") as HTMLInputElement;
                            const fontElement = document.getElementById("customise-engraving-font") as HTMLInputElement;
                            const statusElement = document.querySelector(".engraving-price-value") as HTMLElement;

                            if (customise_engraving_name &&
                                customise_engraving_name.value.trim() === "" &&
                                statusElement && statusElement.textContent &&
                                statusElement.textContent.toLowerCase() !== 'no') {
                                alert("Please enter your engraving");
                                return;
                            }

                            // Check if elements exist before accessing data
                            let font = '';
                            let status = '';

                            if (statusElement && 'dataset' in statusElement) {
                                status = (statusElement as HTMLElement).dataset.status || '';
                            }
                            if (status && status.toLowerCase() !== 'no' && customise_engraving_name) {
                                data.customise.engraving = {
                                    engraving: customise_engraving_name.value,
                                    font: fontElement.value
                                };
                            }

                            // Namenecklace handling
                            const _namenecklace_input = document.querySelector("input[name='namenecklace-input'], textarea[name='namenecklace-input']") as HTMLInputElement | HTMLTextAreaElement | null;
                            if (_namenecklace_input && _namenecklace_input.value === "") {
                                alert("Please enter your name necklace");
                                return;
                            }
                            if (_namenecklace_input) {
                                data.customise.namenecklace = {
                                    name: _namenecklace_input.value
                                };
                            }

                             // Back Namenecklace handling
                            const _back_namenecklace_input = document.querySelector("input[name='back-namenecklace-input'], textarea[name='back-namenecklace-input']") as HTMLInputElement | HTMLTextAreaElement | null;
                            if (_back_namenecklace_input) {
                                data.customise.backname = {
                                    backname: _back_namenecklace_input.value
                                };
                            }



                        }// // end customise
                        // Data GTM Tracking

                        if (product_id !== null) {
                            // let gtmProductData = document.querySelector("input[name=gtm4wp_product_data]") as HTMLInputElement;
                            // let gtmItem;
                            // if (gtmProductData && gtmProductData.value) {
                            //     gtmItem = JSON.parse(gtmProductData.value);
                            //     gtmItem.quantity = "1";
                            //     if (gtmItem.internal_id) {
                            //         gtmItem.id = Number(variation_id);
                            //         gtmItem.item_id = Number(variation_id);
                            //     }
                            //     if (gtmProductData.getAttribute("data-sku")) {
                            //         gtmItem.sku = gtmProductData.getAttribute("data-sku");
                            //     }
                            //     if (gtmProductData.getAttribute("data-variant")) {
                            //         gtmItem.variant = gtmProductData.getAttribute("data-variant");
                            //     }
                            // }

                            handleDisableState(true);
                            handleLoadingState(true);

                            //console.log('data', data);
                            actionAddToCart(data);
                        }
                    }
                });
            }
        });
    }

    // Sticky ATC
    const stickyATC = document.querySelector(".product-sticky__addcart .single_add_to_cart") as HTMLElement;
    const formAtcBtn = document.querySelector(".single_add_to_cart_button") as HTMLButtonElement;
    if (stickyATC && formAtcBtn) {
        stickyATC.addEventListener("click", (event) => {
            event.preventDefault();
            if (formAtcBtn.disabled || formAtcBtn.classList.contains("disabled") || stickyATC.classList.contains("disabled")) {
                return;
            }
            formAtcBtn.click();
        });
    }
};
const syncCart = async () => {
    const { $ajax } = useNuxtApp();

    try {
        const response = await $ajax.get<IMiniCartResponse>(
            'wp-admin/admin-ajax.php?action=emm_sync_cart'
        );

        if (response.success) {
            console.log('sync to cart: done');
        }

    } catch (err: any) {
        console.log('err.response', err);
    }
}

const actionAddToCart = async (data: Record<string, any>) => {
    const wooStore = useWooStore();
    const insiderProductClick = sessionStorage.getItem('insider_active_click')
    console.log('---- insiderProductClick', insiderProductClick)
    const {
        trackCustom
    } = useCustomGtm();

    const {
        trackEventCart
    } = useInsiderSdk();

    const runtimeConfig = useRuntimeConfig();
    const { $ajax } = useNuxtApp();
    handleWoocommerceNotice(false, '');
    const payload = {
      ...data,

      ...(insiderProductClick
        ? { insiderProductClick }
        : {})
    }
    try {
        const response = await $ajax.post<IMiniCartResponse>('/wp-admin/admin-ajax.php', {
            ...data,
             insiderProductClick
        }, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
        //console.log('actionAddToCart', response.datalayer);
        if (response.success) {
            eventCart(response.html, response.total);
            showAddToCartNotification(response.item_name);
            handleDisableState(false);
            handleLoadingState(false);

            if( response?.datalayer ) {
                trackCustom(response.datalayer);
            }

            // Lexer Tracking
            let lexerEventData: { eventName: string, eventValue: string | boolean }[] = [];
            lexerEventData.push({ eventName: 'products_added_to_cart', eventValue: response?.item_name ?? '' });
            lexerEventData.push({ eventName: 'did_start_conversion', eventValue: true })
            lexerTracking(lexerEventData);

            // PWP to cart ======= sdk
            // insider SDK
            if (response?.insider_sdk) {
            console.log('----- insider_sdk atc',response?.insider_sdk)
                 const items = response?.insider_sdk['item'] || [];
                 if (items && items.name) {
                     const currency = response?.insider_sdk['currency'] || 'MYR';
                     trackEventCart('insider_sdk_add_to_cart','add_to_cart',items,currency,'');
                }

                const chain_sdk = response?.insider_sdk['chain_sdk'] || [];
                 if (chain_sdk && chain_sdk.name) {
                     const currency = 'MYR';
                     trackEventCart('insider_sdk_add_to_cart','add_to_cart',chain_sdk,currency,'');
                 }

     
             }
            // end insider SDK

             // insider search

           if (response?.insider_search) {
                const payload = response?.insider_search || '';
                if (payload != '') {
                     const platform: 'desktop-web' | 'mobile-web' =
                    window.innerWidth <= 768 ? 'mobile-web' : 'desktop-web';
                    const uid = payload.userId || '';

                    const uuid = getUUidInsiderSearch(uid);

                    // const uuid = userStore.dataInsiderSdk?.uuid || '';
                    // const uid = getUUidInsiderSearch(uuid) || 'guest';

                    payload.platform = platform;
                    payload.userId = uuid;

                   console.log('✅ Insider payload cart--:', payload)
                     sendInsiderEvent(payload)
                }
               
           }
           // end insider search

           syncCart();

            
        } else {
            handleDisableState(false);
            handleLoadingState(false);
            if (response.message !== '') {
                handleWoocommerceNotice(true, response.message);
            }
        }
        atcAlreadyInProcess.value = false;
    } catch (err: any) {
        handleWoocommerceNotice(false, '');
        handleDisableState(false);
        handleLoadingState(false);
        atcAlreadyInProcess.value = false;
        //console.log('err.response', err);
    }
};
const checkValidateBundle = async (data: Record<string, any>, bundleATCData: Record<string, any>) => {
    const runtimeConfig = useRuntimeConfig();
    const { $ajax } = useNuxtApp();

    try {
        const response = await $ajax.post<ICheckValidateBundle>('/wp-admin/admin-ajax.php', {
            ...data,
        }, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });

        if (response.success) {
            // Can added to cart
            handleDisableState(false);
            handleLoadingState(false);
            // Handle Add Bundle to Cart
            addBundleToCart(bundleATCData);
        } else {
            // Can not added to cart
            // Handle Error Message
            handleDisableState(false);
            handleLoadingState(false);
            handleWoocommerceNotice(true, response.message);
        }
    } catch (err: any) {
        handleDisableState(false);
        handleLoadingState(false);
        //console.log('err.response', err);
    }
};
const addBundleToCart = async (data: Record<string, any>) => {
    const {
        trackCustom
    } = useCustomGtm();
    
    const {
        trackEventCart
    } = useInsiderSdk();
    const runtimeConfig = useRuntimeConfig();
    const { $ajax } = useNuxtApp();
    handleDisableState(true);
    handleLoadingState(true);
    handleWoocommerceNotice(false, '');
    try {
        const response = await $ajax.post<IMiniCartResponse>('/wp-admin/admin-ajax.php', {
            ...data,
        }, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });

        //console.log('addBundleToCart');
        if (response.success) {
            eventCart(response.html, response.total);
            showAddToCartNotification(response.item_name);
            handleDisableState(false);
            handleLoadingState(false);

            if( response?.datalayer ) {
                trackCustom(response.datalayer);
            }

            syncCart();

            // Lexer Tracking
            let lexerEventData: { eventName: string, eventValue: string | boolean }[] = [];
            lexerEventData.push({ eventName: 'products_added_to_cart', eventValue: response.item_name ?? '' });
            lexerEventData.push({ eventName: 'did_start_conversion', eventValue: true })
            lexerTracking(lexerEventData);

            // PWP to cart ======= sdk
            // insider SDK
            if (response?.insider_sdk) {
                 const items = response?.insider_sdk['item'] || [];
                 if (items && items.name) {
                   // console.log('kkkkkkkk');
                     const currency = 'MYR';
                     trackEventCart('insider_sdk_add_to_cart','add_to_cart',items,currency,'');
                }

                const chain_sdk = response?.insider_sdk['chain_sdk'] || [];
                 if (chain_sdk && chain_sdk.name) {
                     const currency = 'MYR';
                     trackEventCart('insider_sdk_add_to_cart','add_to_cart',chain_sdk,currency,'');
                }
     
             }
            // end insider SDK

        } else {
            // Handle Error Message
            handleDisableState(false);
            handleLoadingState(false);
            handleWoocommerceNotice(true, response.message);
        }
    } catch (err: any) {
        handleDisableState(false);
        handleLoadingState(false);
        //console.log('err.response', err);
    }
}

const handleLoadingState = (isLoading: boolean) => {
    const stickyBtn = document.querySelector(".product-sticky__addcart .single_add_to_cart") as HTMLElement;
    if (stickyBtn) {
        if (isLoading) {
            stickyBtn.classList.add("isloading");
        } else {
            stickyBtn.classList.remove("isloading");
        }
    }
    const atcBtn = document.querySelector(".single_add_to_cart_button") as HTMLElement;
    if (atcBtn) {
        if (isLoading) {
            atcBtn.classList.add("isloading");
        } else {
            atcBtn.classList.remove("isloading");
        }
    }
}
const handleDisableState = (isDisabled: boolean) => {
    const stickyBtn = document.querySelector(".product-sticky__addcart .single_add_to_cart") as HTMLElement;
    if (stickyBtn) {
        if (isDisabled) {
            stickyBtn.classList.add("disabled");
        } else {
            stickyBtn.classList.remove("disabled");
            stickyBtn.blur();
        }
    }
    const atcBtn = document.querySelector(".single_add_to_cart_button") as HTMLElement;
    if (atcBtn) {
        if (isDisabled) {
            atcBtn.classList.add("disabled");
        } else {
            atcBtn.classList.remove("disabled");
            atcBtn.blur();
        }
    }
}
const handleWoocommerceNotice = (show: boolean, message: string) => {
    const noticeWrapper = document.querySelector<HTMLElement>(".woocommerce-notices-wrapper")
    if (noticeWrapper) {
        if (show && message) {
            noticeWrapper.classList.add("active");
            noticeWrapper.innerHTML = message;
            noticeWrapper.scrollIntoView({ behavior: "smooth", block: "start" });
        } else {
            noticeWrapper.classList.remove("active");
            noticeWrapper.innerHTML = '';
        }
    }
}
export const lexerTracking = (eventDatas: { eventName: string, eventValue: string | boolean }[]) => {
    // Lexer Tracking
    if (window.lxt && typeof window.lxt !== 'undefined') {
        if (eventDatas.length > 0) {
            eventDatas.forEach(eventData => {
                console.warn('Lexer Track', `lxt('track', ${eventData.eventName}, ${eventData.eventValue})`);
                window.lxt('track', eventData.eventName, eventData.eventValue);
            });
        }
    }
}
